import React from 'react';
import BusinessDocumentSystem from './components/BusinessDocumentSystem';
import { TeachingModeProvider } from './contexts/TeachingModeContext';
import './App.css';

function App() {
  return (
    <div className="App">
      <TeachingModeProvider>
        <BusinessDocumentSystem />
      </TeachingModeProvider>
    </div>
  );
}

export default App; 